import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import TableroView from './TableroView';
import * as ROUTES from '../../../router/Routes';

const TableroModule = () => {
  return (
    <ContainerTemplate active={ROUTES.tablero} routes={[]}>
      <TableroView />
    </ContainerTemplate>
  );
};

export default TableroModule;
